import axios from "axios";

/**
 * API client.
 *
 * In Emergent preview / dev → REACT_APP_BACKEND_URL is set and points at the FastAPI
 * service (used for local development).
 *
 * In production on Cloudflare Pages → REACT_APP_BACKEND_URL is unset and requests use
 * relative paths, which Cloudflare routes to /functions/api/* (e.g. contact.js).
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export default api;
